<template>
    <div class="max-w-(--breakpoint-sm) flex flex-col gap-4">
        <page-header>Notifications</page-header>

        <vx-expandable-card>
            <template v-slot:content>
                <div class="flex items-center justify-between gap-4">
                    <div>
                        <span class="text-base font-bold text-slate-900">Notification sounds</span>
                        <p class="text-sm text-slate-500">
                            Play a sound when a new message arrives. This setting only applies to this browser.
                        </p>
                    </div>
                    <vx-toggle v-model="soundsEnabled" size="lg" data-test="notification-sounds-toggle"></vx-toggle>
                </div>
            </template>
        </vx-expandable-card>
    </div>
</template>

<script lang="ts" setup>
import { VxExpandableCard, VxToggle } from '@voxie/frontend-components';
import PageHeader from '~/components/general/PageHeader.vue';
import { useNotificationSounds } from '~/composables/useNotificationSounds';

const { soundsEnabled } = useNotificationSounds();
</script>
